(function () {
  var cfg = window.__jp;
  if (!cfg) return;

  var variants     = cfg.variants;
  var colorPos     = cfg.colorPos;
  var sizePos      = cfg.sizePos;
  var selectedColor = cfg.selectedColor || null;
  var selectedSize  = cfg.selectedSize  || null;

  var variantIdEl  = document.getElementById('jp-variant-id');
  var priceEl      = document.getElementById('jp-price');
  var addBtn       = document.getElementById('jp-add-btn');
  var colorNameEl  = document.getElementById('jp-color-name');
  var restockEl    = document.getElementById('jp-restock');
  var releaseNoteEl = document.querySelector('.jp-release-note');
  var addCalBtn    = document.getElementById('jp-addcal-btn');

  var releaseTs    = cfg.releaseTs || 0;
  var isPrerelease = releaseTs > Math.floor(Date.now() / 1000);
  var countdownTimer;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  // カウントダウンを1行のままボタンに収める。
  // まず字間を詰め、それでも足りなければ文字サイズを縮める（下限 6px）。
  function fitCountdown() {
    var label = document.querySelector('.jp-countdown-label');
    if (!label || !addBtn) return;
    label.style.fontSize = '';
    label.style.letterSpacing = '';
    var cs = getComputedStyle(addBtn);
    var avail = addBtn.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    if (avail <= 0) return;
    if (label.getBoundingClientRect().width <= avail) return;
    label.style.letterSpacing = '0.06em';
    var w = label.getBoundingClientRect().width;
    if (w > avail) {
      var fs = parseFloat(getComputedStyle(label).fontSize);
      label.style.fontSize = Math.max(6, fs * avail / w * 0.98).toFixed(2) + 'px';
    }
  }

  function renderCountdown() {
    var remaining = releaseTs - Math.floor(Date.now() / 1000);
    if (remaining <= 0) {
      clearInterval(countdownTimer);
      isPrerelease = false;
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.classList.remove('is-prerelease');
      }
      if (releaseNoteEl) releaseNoteEl.hidden = true;
      if (addCalBtn) addCalBtn.hidden = true;
      update();
      return;
    }
    var days = Math.floor(remaining / 86400);
    var hrs  = Math.floor((remaining % 86400) / 3600);
    var mins = Math.floor((remaining % 3600) / 60);
    var secs = remaining % 60;
    var countdownEl = document.getElementById('jp-countdown');
    if (countdownEl) {
      // 「02 DAYS  08 HOURS  43 MIN  46 SEC」。1 のときだけ単数形（DAY / HOUR）。
      var parts = [
        pad(days) + (days === 1 ? ' DAY'  : ' DAYS'),
        pad(hrs)  + (hrs  === 1 ? ' HOUR' : ' HOURS'),
        pad(mins) + ' MIN',
        pad(secs) + ' SEC'
      ];
      countdownEl.innerHTML = parts.map(function (t) { return '<span>' + t + '</span>'; }).join('');
      fitCountdown();
    }
  }

  function optVal(v, pos) {
    if (pos === 1) return v.option1;
    if (pos === 2) return v.option2;
    if (pos === 3) return v.option3;
    return null;
  }

  function findVariant() {
    return variants.find(function (v) {
      var c = !colorPos || !selectedColor || optVal(v, colorPos) === selectedColor;
      var s = !sizePos  || !selectedSize  || optVal(v, sizePos)  === selectedSize;
      return c && s;
    });
  }

  function getFormattedPrice(variantId) {
    var el = document.querySelector('#jp-prices [data-variant="' + variantId + '"]');
    return el ? el.textContent.trim() : '';
  }

  function updateSizeAvailability() {
    document.querySelectorAll('.jp-size-btn').forEach(function (btn) {
      var size = btn.dataset.size;
      var v = variants.find(function (variant) {
        var c = !colorPos || !selectedColor || optVal(variant, colorPos) === selectedColor;
        var s = !sizePos  || optVal(variant, sizePos) === size;
        return c && s;
      });
      // 発売前は在庫状況（完売表示）を見せない
      if (isPrerelease || (v && v.available)) {
        btn.classList.remove('is-soldout');
      } else {
        btn.classList.add('is-soldout');
      }
    });
  }

  function update() {
    var variant = findVariant();
    if (!variant) return;

    if (variantIdEl) variantIdEl.value = variant.id;

    var price = getFormattedPrice(variant.id);
    if (priceEl && price) priceEl.textContent = price;

    if (addBtn && !isPrerelease) {
      if (variant.available) {
        addBtn.textContent = 'ADD TO CART';
        addBtn.classList.remove('is-soldout');
        addBtn.disabled = false;
        if (restockEl) restockEl.hidden = true;
      } else {
        addBtn.textContent = 'SOLD OUT';
        addBtn.classList.add('is-soldout');
        addBtn.disabled = true;
        if (restockEl) restockEl.hidden = false;
      }
    }

    updateSizeAvailability();
  }

  // Color swatch selection
  document.querySelectorAll('.jp-swatch').forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectedColor = btn.dataset.color;
      document.querySelectorAll('.jp-swatch').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      if (colorNameEl) colorNameEl.textContent = selectedColor.toUpperCase();
      update();
    });
  });

  // Size button selection
  document.querySelectorAll('.jp-size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-soldout')) return;
      selectedSize = btn.dataset.size;
      document.querySelectorAll('.jp-size-btn').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      update();
    });
  });

  update();

  if (isPrerelease && addBtn) {
    renderCountdown();
    countdownTimer = setInterval(renderCountdown, 1000);
    window.addEventListener('resize', fitCountdown);
  }

  // "ADD TO CALENDAR APP" ボタン
  // Google カレンダー直リンクは未ログインだと宣伝ページに飛ばされ、
  // iOS 標準カレンダー利用者はそもそも使えなかったため .ics 生成に変更。
  // .ics はカレンダーの標準形式で iOS / macOS / Google / Outlook すべてが開ける。
  if (addCalBtn && releaseTs) {
    addCalBtn.addEventListener('click', function () {
      function icsStamp(d) {
        return d.getUTCFullYear() + pad(d.getUTCMonth() + 1) + pad(d.getUTCDate()) + 'T' +
          pad(d.getUTCHours()) + pad(d.getUTCMinutes()) + pad(d.getUTCSeconds()) + 'Z';
      }
      // RFC5545: カンマ・セミコロン・改行はエスケープが必要
      function esc(t) {
        return String(t).replace(/\\/g, '\\\\').replace(/;/g, '\\;')
                        .replace(/,/g, '\\,').replace(/\r?\n/g, '\\n');
      }
      // 1行75オクテット制限。日本語が混ざるのでバイト単位で折る
      function fold(line) {
        var out = '', buf = '', bytes = 0;
        for (var i = 0; i < line.length; i++) {
          var ch = line[i];
          var n = unescape(encodeURIComponent(ch)).length;
          if (bytes + n > 73) { out += buf + '\r\n '; buf = ''; bytes = 0; }
          buf += ch; bytes += n;
        }
        return out + buf;
      }

      var start = new Date(releaseTs * 1000);
      var end   = new Date((releaseTs + 3600) * 1000);
      var title = (cfg.productTitle || document.title) + ' — ON SALE';
      var url   = cfg.productUrl || window.location.href;
      var uid   = 'jianye-' + (cfg.productId || 'release') + '-' + releaseTs + '@jianye.online';

      var lines = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//JIAN YE//Release//EN',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        'UID:' + uid,
        'DTSTAMP:' + icsStamp(new Date()),
        'DTSTART:' + icsStamp(start),
        'DTEND:'   + icsStamp(end),
        'SUMMARY:' + esc(title),
        'DESCRIPTION:' + esc(url),
        'URL:' + esc(url),
        'BEGIN:VALARM',
        'TRIGGER:-PT15M',
        'ACTION:DISPLAY',
        'DESCRIPTION:' + esc(title),
        'END:VALARM',
        'END:VEVENT',
        'END:VCALENDAR'
      ].map(fold);

      var ics  = lines.join('\r\n') + '\r\n';
      var blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
      var href = URL.createObjectURL(blob);
      var name = (cfg.productTitle || 'release').replace(/[^\w\-]+/g, '-').replace(/^-+|-+$/g, '') + '.ics';

      var a = document.createElement('a');
      a.href = href;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(href); }, 4000);
    });
  }

  // ── 右カラムの高さ調整 ─────────────────────────────────────
  // .jp-info は sticky。吸着後の上端は 80px だが、ページ最上部ではまだ
  // 自然位置（約120px）にいるため、固定値だとどちらかで過不足が出る。
  // 現在の上端を見て、常にビューポート内に収まる最大の高さを与える。
  (function () {
    var info = document.querySelector('.jp-info');
    if (!info || !window.matchMedia('(min-width: 769px)').matches) return;

    var queued = false;
    function fit() {
      queued = false;
      // 高さを解除すると scrollTop が 0 に丸められるため、位置を控えて戻す
      var keep = info.scrollTop;
      // 高さを一旦解除してから素の上端位置を測る
      info.style.setProperty('--jp-info-max', 'none');
      var top = info.getBoundingClientRect().top;
      // 画面下端にぴったり付けると最終行が縁に貼り付き、右下の朱マークとも干渉する。
      // 56px 空けて左カラムの余白リズムに揃える。
      info.style.setProperty('--jp-info-max', Math.max(240, window.innerHeight - top - 56) + 'px');
      info.scrollTop = keep;
    }
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(fit);
    }

    fit();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    // アコーディオンの開閉で中身の高さが変わる
    document.querySelectorAll('.jp-accordion').forEach(function (d) {
      d.addEventListener('toggle', schedule);
    });
  })();

  // ── Stockist map (Leaflet.js) ─────────────────────────────
  var stockistDetails = document.getElementById('jp-stockist-details');
  var mapInitialized  = false;

  function initStockistMap() {
    if (mapInitialized) return;
    if (!window.L) return;

    var mapEl     = document.getElementById('jp-stockist-map');
    var listItems = document.querySelectorAll('.jp-store-item[data-lat]');
    if (!mapEl || !listItems.length) return;

    mapInitialized = true;

    // ホイールは右カラムのスクロールに使う。地図の上でホイールを奪うと
    // カラムが途中で止まるため、拡大縮小は地図をクリックしたときだけ有効にする。
    var map = L.map('jp-stockist-map', { zoomControl: false, scrollWheelZoom: false });
    var mapEl = document.getElementById('jp-stockist-map');
    map.on('click', function () { map.scrollWheelZoom.enable(); });
    mapEl.addEventListener('mouseleave', function () { map.scrollWheelZoom.disable(); });

    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
      attribution: '&copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
      maxZoom: 16
    }).addTo(map);

    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}', {
      maxZoom: 16
    }).addTo(map);

    L.control.zoom({ position: 'bottomright' }).addTo(map);

    var dotIcon = L.divIcon({
      className: '',
      html: '<div class="jp-map-dot"></div>',
      iconSize: [10, 10],
      iconAnchor: [5, 5],
      popupAnchor: [0, -8]
    });

    var latLngs = [];

    listItems.forEach(function (item) {
      var lat  = parseFloat(item.dataset.lat);
      var lng  = parseFloat(item.dataset.lng);
      var name = item.dataset.name || '';
      var url  = item.dataset.url  || '';
      if (!lat || !lng) return;

      var popup =
        '<div class="jp-map-popup">' +
        '<strong>' + name.toUpperCase() + '</strong>' +
        (url ? '<a href="' + url + '" target="_blank" rel="noopener">VISIT STORE ↗</a>' : '') +
        '</div>';

      var marker = L.marker([lat, lng], { icon: dotIcon })
        .bindPopup(popup, { closeButton: false, className: 'jp-leaflet-popup' })
        .addTo(map);

      marker.on('click', function () {
        listItems.forEach(function (li) { li.classList.remove('is-active'); });
        item.classList.add('is-active');
      });

      item.addEventListener('click', function (e) {
        if (!item.classList.contains('is-active')) {
          e.preventDefault();
          map.setView([lat, lng], 13);
          marker.openPopup();
          listItems.forEach(function (li) { li.classList.remove('is-active'); });
          item.classList.add('is-active');
        }
      });

      latLngs.push([lat, lng]);
    });

    if (latLngs.length === 1) {
      map.setView(latLngs[0], 14);
    } else if (latLngs.length > 1) {
      map.fitBounds(latLngs, { padding: [32, 32] });
    }
  }

  if (stockistDetails) {
    stockistDetails.addEventListener('toggle', function () {
      if (this.open) {
        requestAnimationFrame(function () { initStockistMap(); });
      }
    });
  }

  // YOU MAY ALSO LIKE — Shopify Section Rendering API
  var productId = cfg.productId;
  if (productId) {
    fetch(
      '/recommendations/products?section_id=product-recommendations&product_id=' +
      productId +
      '&limit=4'
    )
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var grid = document.getElementById('jp-recs-grid');
        var recs = document.getElementById('jp-recs');
        if (!grid || !recs) return;

        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        // Section rendering wraps content in a <div class="shopify-section">
        var inner = tmp.querySelector('.shopify-section') || tmp;
        var cards = inner.querySelectorAll('.jp-rec-card');
        if (cards.length === 0) return;

        cards.forEach(function (card) {
          grid.appendChild(card);
        });

        recs.removeAttribute('aria-hidden');
      })
      .catch(function () {});
  }

  // ── Gallery videos: keep looping at all times ───────────
  // ブラウザは画面外・タブ非表示・省電力モードで自動再生を止めるため、
  // 見えている間は必ず再生し続け、止まったら再開する。
  var galleryVideos = Array.prototype.slice.call(document.querySelectorAll('.jp-images__item video'));

  if (galleryVideos.length) {
    var playVideo = function (v) {
      v.muted = true;
      v.loop = true;
      var p = v.play();
      if (p && p.catch) { p.catch(function () {}); }
    };

    var visible = new Set();

    if ('IntersectionObserver' in window) {
      var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            visible.add(entry.target);
            playVideo(entry.target);
          } else {
            visible.delete(entry.target);
          }
        });
      }, { threshold: 0.25 });
      galleryVideos.forEach(function (v) { videoObserver.observe(v); });
    } else {
      galleryVideos.forEach(function (v) { visible.add(v); playVideo(v); });
    }

    galleryVideos.forEach(function (v) {
      // loop が効かない環境への保険：終わったら頭から再生し直す
      v.addEventListener('ended', function () { v.currentTime = 0; playVideo(v); });
      // 通信の詰まりなどで止まった場合の再開
      v.addEventListener('stalled', function () { if (visible.has(v)) playVideo(v); });
      v.addEventListener('pause', function () {
        if (visible.has(v) && !document.hidden && !v.ended) { setTimeout(function () { if (v.paused && visible.has(v)) playVideo(v); }, 300); }
      });
    });

    // タブに戻ったときに再開
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) { visible.forEach(playVideo); }
    });

    // 省電力モードなどで自動再生が拒否された場合、最初の操作で再開
    var resumeOnGesture = function () {
      visible.forEach(function (v) { if (v.paused) playVideo(v); });
    };
    ['touchstart', 'pointerdown', 'scroll'].forEach(function (ev) {
      window.addEventListener(ev, resumeOnGesture, { passive: true, once: true });
    });
  }

  // ── Mobile: swipe gallery <-> progress bar sync ─────────
  var imagesEl = document.getElementById('jp-images');
  var progress = document.getElementById('jp-thumbstrip');

  if (imagesEl && progress) {
    var items = Array.prototype.slice.call(imagesEl.querySelectorAll('.jp-images__item'));
    var bars  = Array.prototype.slice.call(progress.querySelectorAll('.jp-progress__bar'));

    bars.forEach(function (bar, i) {
      bar.addEventListener('click', function () {
        if (items[i]) {
          items[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      });
    });

    var scrollTimer = null;
    imagesEl.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var scrollLeft = imagesEl.scrollLeft;
        var width = imagesEl.clientWidth || 1;
        var index = Math.round(scrollLeft / width);
        bars.forEach(function (b, i) {
          b.classList.toggle('is-active', i === index);
        });
      }, 80);
    }, { passive: true });
  }
})();
